<template>

  <b-col 
    class="px-4 mt-5 mx-auto" 
    cols="12" md="10" lg='8'
  ><loader v-if="loader"></loader>
    <form 
      class="change-mail-form p-2 m-2" 
      @submit.prevent="UpdateSubscription"
      novalidate
    >
      <h4 class="mb-3 form-header">{{'userProfileSubscriptions' | localize}}:</h4>
      <div class=" mt-1 mb-1 delete-profile-description">
        {{'userProfileSubscriptionsDescription' | localize}}
      </div>
      <div v-if="account_numbers.length > 1" class="input-group mb-3 ">
        <div class="input-group-text">{{ 'LSList' | localize }}</div>
        <b-form-select v-model="account_number" :options="account_numbers" class="form-control" @change="FetchSubscriptionsByAccount"></b-form-select>
      </div>
      <div class="profile-checklist">
        <b-form-checkbox
            id="checkbox-1"
            v-model="change_schet"
            name="change_schet"
            value="1"
            unchecked-value="0"
            stacked
        >
           {{ 'account_changes_notify' | localize }}
        </b-form-checkbox>

        <b-form-checkbox
            id="checkbox-2"
            v-model="nachisl"
            name="nachisl"
            value="1"
            unchecked-value="0"
            stacked
        >
          {{ 'new_accruals_notify' | localize }}
        </b-form-checkbox>

        <b-form-checkbox
            id="checkbox-3"
            v-model="schet"
            name="schet"
            value="1"
            unchecked-value="0"
            stacked
        >
          {{ 'send_accruals_paperless' | localize }}
        </b-form-checkbox>

        <b-form-checkbox
            id="checkbox-4"
            v-model="zadolg"
            name="zadolg"
            value="1"
            unchecked-value="0"
            stacked
        >
          {{ 'remind_arrears' | localize }}
        </b-form-checkbox>


      </div>

      <b-button
        class="mt-5 mb-0 style-button button-profile-width"
        type="submit"
        variant="outline-danger"
      >
        {{'userProfileSubscriptionsButton' | localize}}
        <div class="style-button-icon"> 
          <b-icon  icon="check2-circle" ></b-icon>
        </div> 
      </b-button>
    </form>
  </b-col>  
</template>
<script>
import config from '@/config'
import loader from '../../../components/Loader'
import {sha256} from "js-sha256";
import base64url from "base64url";
import axios from "axios";
import {mapGetters} from "vuex";


export default {
  data:()=> ({
    loader: false,
    change_schet: "0",
    nachisl: "0",
    schet: "0",
    zadolg: "0",
    account_number: 0,
    account_numbers: []
  }),
  computed: mapGetters(['userAccountsNumbers', 'locale']),
  mounted: async function () {
    let account_options = []
    this.loader = true
    localStorage.setItem('weltumLastUrl', window.location.pathname)
    await this.$store.dispatch('userAccountsFetch')
    if (typeof this.userAccountsNumbers.length !== 'undefined' && this.userAccountsNumbers[0].err === "Сессия просрочена !") {
      await this.$store.dispatch('logout')
      this.$router.push({path: `${config.ROUTE_PREFIX}/login`})
      this.$toastLocalized("sessionTerminated")
    }
    if (typeof this.userAccountsNumbers.length !== 'undefined') this.userAccountsNumbers.map(function(account_number) {
      account_options.push( {"value": account_number.account_id, "text": account_number.account_id})
    })
    this.account_numbers = account_options
    this.FetchSubscriptionsByAccount(this.userAccountsNumbers[0].account_id)
    this.loader = false
  },
  methods: {
    async UpdateSubscription(){
      this.loader = true
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.post(
          `${config.API_URL}/api/rest/receipt/razsylka_put_info`,
          {
            "kod_lica": parseInt(this.account_number),
            "change_schet": parseInt(this.change_schet),
            "nachisl": parseInt(this.nachisl),
            "schet": parseInt(this.schet),
            "zadolg": parseInt(this.zadolg),
            "secret_key": key
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Hmac': Hmac,
              'X-Time': Time,
            }
          },
      ).then((response) => {
        this.loader = false
        if(response.data.cod === "1"){
          this.$router.push({path: `${config.ROUTE_PREFIX}/login`})
          this.$toastLocalized("sessionTerminated")
        }
        if(response.data.cod === "0"){
          this.FetchSubscriptionsByAccount(this.account_number)
          this.$messageLocalized("dataChanged")
        }
      })
    },
    async FetchSubscriptionsByAccount(account_id){
      this.loader = true
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.get(
          `${config.API_URL}/api/rest/receipt/razsylka_get_info?lico=${account_id}&secret_key=${key}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Hmac': Hmac,
              'X-Time': Time,
            }
          },
      ).then((response) => {
       this.account_number = account_id
       this.change_schet = response.data.items[0].change_schet.toString()
       this.nachisl = response.data.items[0].nachisl.toString()
       this.schet = response.data.items[0].schet.toString()
       this.zadolg = response.data.items[0].zadolg.toString()
       this.loader = false
      })
    }
  },
  components: {loader}
}
</script>